module.exports = __webpack_public_path__ + "logo.svg?97e5e7a3a52d4750397345d8775008d1";